import React, {Component} from 'react';
import './Course.css';
class Course extends Component {

    render() {

        var title = this.props.data['course'];
        var topics = this.props.data['topics'];
        var url = this.props.data['url'];

        return <div className="Course">
            <div className="Title"><a href={url} target="_blank" rel="noopener noreferrer">{title}</a></div>
            <div className="Topics">{topics.map((topic, index)=>{
                return <div key={"topics"+index}>{topic}</div>
            })}</div>
        </div>;

    }
}

export default Course;


// WEBPACK FOOTER //
// ./src/Course.js